var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.96094 0.816406L5.41406 1.33594C5.27734 1.47266 5.27734 1.69141 5.41406 1.80078L9.65234 6.03906H0.328125C0.136719 6.03906 0 6.20312 0 6.36719V7.13281C0 7.32422 0.136719 7.46094 0.328125 7.46094H9.65234L5.41406 11.7266C5.27734 11.8359 5.27734 12.0547 5.41406 12.1914L5.96094 12.7109C6.07031 12.8477 6.28906 12.8477 6.42578 12.7109L12.1406 6.99609C12.2773 6.85938 12.2773 6.66797 12.1406 6.53125L6.42578 0.816406C6.28906 0.679688 6.07031 0.679688 5.96094 0.816406Z",
    fill: "#1D3066"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.864d48f1e4547b5d80dec4d011d3198a.svg";
export { ForwardRef as ReactComponent };